// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.css'
import '@/css/selectors.css'
import * as uiv from 'uiv'
import moment from 'moment'
import locale from 'uiv/src/locale/lang/zh-CN'
import Print from 'vue-print-nb'
import MessageCenter from './MessageCenter'

Vue.use(MessageCenter)
Vue.use(Print)
Vue.use(uiv, {locale})
Vue.config.productionTip = false

// 注册
Vue.filter('dt', function (value) {
  const v = moment(value).format('YYYY-MM-DD HH:mm:ss')
  if (v === '0001-01-01 08:05:43') {
    return '未知'
  }
  return v === '0001-01-01 00:00:00' ? '无记录' : v
})

Vue.filter('date', function(value) {
  const v = moment(value).format('YYYY-MM-DD')
  return v === '0001-01-01' ? '无记录' : v
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js